import { atom } from "recoil";

export const calendarDataState = atom({
  key: "calendarDataState",
  default: "",
});
